"use client";

import styles from "../css/reverseStock.module.css";
import Navbar from "../../../../components/navbar.jsx";
import Footer from "../../../../components/footer.jsx";
import Header from "../components/Header.jsx";
import ViewRenderer from "../components/ViewRenderer.jsx";
import useReverseStock from "../components/useReverseStock.jsx";

export default function ReverseStock() {
  const rs = useReverseStock();

  return (
    <div className={styles.wrapper}>
      <Navbar />
      <div className={styles.dashboardLayout}>
        <main className={styles.main}>
          <div className={styles.container}>
            <Header
              roleId={rs.roleId}
              activeSegment={rs.activeSegment}
              onSegmentChange={rs.handleSegmentChange}
              mode={rs.mode}
              setMode={rs.setMode}
            />

            <ViewRenderer
              roleId={rs.roleId}
              activeSegment={rs.activeSegment}
              mode={rs.mode}
              fromDate={rs.fromDate}
              setFromDate={rs.setFromDate}
              toDate={rs.toDate}
              setToDate={rs.setToDate}
              currentPage={rs.currentPage}
              setCurrentPage={rs.setCurrentPage}
              totalPages={rs.totalPages}
              pageData={rs.pageData}
              selectAll={rs.selectAll}
              toggleSelectAll={rs.toggleSelectAll}
              handleReturnToStock={rs.handleReturnToStock}
              columns={rs.columns}
              historyColumns={rs.historyColumns}
              detailColumns={rs.detailColumns}
              frontShopDetailColumns={rs.frontShopDetailColumns}
              otcDetailColumnsPending={rs.otcDetailColumnsPending}
              historyDetailColumns={rs.historyDetailColumns}
              frontShopHistoryDetailColumns={rs.frontShopHistoryDetailColumns}
              otcHistoryDetailColumns={rs.otcHistoryDetailColumns}
            />
          </div>
        </main>
      </div>
      <div className={styles.footerWrapper}>
        <Footer />
      </div>
    </div>
  );
}

